import { SVGProps } from 'react';

const SvgSecurityLock = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 18" {...props}>
        <path d="M14 7.778c0 4.316-2.987 8.353-7 9.333-4.013-.98-7-5.017-7-9.333V3.11L7 0l7 3.111v4.667Zm-7 7.778c2.917-.778 5.444-4.247 5.444-7.607V4.122L7 1.696 1.556 4.122V7.95c0 3.36 2.527 6.829 5.444 7.607Zm2.178-7.778V6.61c0-1.089-1.09-1.944-2.178-1.944-1.089 0-2.178.855-2.178 1.944v1.167c-.466 0-.933.466-.933.933v2.722c0 .545.467 1.011.933 1.011H9.1c.544 0 1.011-.466 1.011-.933V8.79c0-.545-.467-1.011-.933-1.011Zm-1.011 0H5.833V6.61C5.833 5.99 6.378 5.6 7 5.6s1.167.389 1.167 1.011v1.167Z" />
    </svg>
);
export default SvgSecurityLock;
